import React from "react";

import {
  currencyFormat,
  getValue,
  getCurrencySymbol,
  convertDate,
  formatYearMonthToShortMonthYear,
} from "components/Screens/CommonUtils";
import ChipComp from "components/common/Chip";

import {
  CalendarMonthOutlined as CalendarMonthOutlinedIcon,
  VisibilityOutlined as VisibilityOutlinedIcon,
  FileDownloadOutlined as FileDownloadOutlinedIcon,
  EmailOutlined as EmailOutlinedIcon,
  ReplayOutlined as ReplayOutlinedIcon,
} from "@mui/icons-material";

import CUSTOMER_PAYROLL_STATUS from "constants/customer.constants";

import "./PaymentHistoryColumns.scss";

const getStatusComponent = (status, row, onRetry, source) => {
  switch (status) {
    case CUSTOMER_PAYROLL_STATUS.PAID:
      return <ChipComp labelClass="para-body-s-medium" label="Paid" color="success" />;
    case CUSTOMER_PAYROLL_STATUS.UNPAID:
      return <ChipComp labelClass="para-body-s-medium" label="Draft" color="warning" />;
    case CUSTOMER_PAYROLL_STATUS.FAILED:
      return (
        <ChipComp
          endIcon={
            source !== "customer" ? (
              <ReplayOutlinedIcon
                onClick={(e) => {
                  e.stopPropagation();
                  onRetry?.(row);
                }}
                className="payment-failed-retry-icon"
              />
            ) : null
          }
          labelClass="para-body-s-medium"
          label="Failed"
          color="error"
        />
      );
    case CUSTOMER_PAYROLL_STATUS.VOID:
      return <ChipComp labelClass="para-body-s-medium" label="Void" color="default" />;
    default:
      return <ChipComp labelClass="para-body-s-medium" label="Processing" color="warning" />;
  }
};

const customerPaymentSummaryColumns = ({ onRetry, showSendInvoiceEmail = false }, source) => [
  {
    id: "billingPeriod",
    label: "Billing Period",
    render: (billingPeriod) => {
      return (
        <div className="flex items-center">
          <div>
            <CalendarMonthOutlinedIcon className="calendar-month-icon" />
          </div>
          <div className="para-body-m-regular">{formatYearMonthToShortMonthYear(billingPeriod)}</div>
        </div>
      );
    },
  },
  {
    id: "billedOn",
    label: "Billed On",
    render: (billedOn) => <p>{convertDate(billedOn)}</p>,
  },
  {
    id: "dueDate",
    label: "Due Date",
    render: (dueDate) => <p>{convertDate(dueDate)}</p>,
  },
  {
    id: "paidOn",
    label: "Paid On",
    render: (paidOn) => <p>{convertDate(paidOn)}</p>,
  },
  {
    id: "paymentType",
    label: "Payment Type",
  },
  {
    id: "total",
    label: "Total",
    render: (total) => <p>{getCurrencySymbol("en-US", "USD", currencyFormat(getValue(total)))}</p>,
  },
  {
    id: "status",
    label: "Status",
    render: (status, row) => getStatusComponent(status, row, onRetry, source),
  },
  {
    id: "actions",
    minWidth: 100,
    type: "action",
    sortable: false,
    actions: [
      {
        icon: <VisibilityOutlinedIcon className="action-visibility-icon" />,
        label: "View",
        disabled: (row) =>
          (row?.paymentType === "One-time" && source !== "customer") || row?.paymentType === "Onboarding",
      },
      {
        icon: <EmailOutlinedIcon />,
        label: "SendInvoiceEmail",
        hidden: !showSendInvoiceEmail,
      },
      {
        icon: <FileDownloadOutlinedIcon className="action-download-icon" />,
        label: "Download",
      },
    ],
  },
];

export default customerPaymentSummaryColumns;
